import Pusher from 'pusher-js'
import { useAuthStore } from '@/stores/authStore'

let pusher = null
const subscribedChannels = new Map()
let authStore

export function initPusher() {
  authStore = useAuthStore()
  if (pusher) return

  if (!authStore.token || !authStore.user?.id) {
    console.warn('No user/token, skipping pusher init')
    return
  }

  pusher = new Pusher(import.meta.env.VITE_APP_PUSHER_KEY, {
    cluster: import.meta.env.VITE_APP_PUSHER_CLUSTER,
    authEndpoint: `${import.meta.env.VITE_APP_BACKEND_URL}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${authStore.token}`
      }
    }
  })
}

function subscribeToChannel(channelName) {
  if (!subscribedChannels.has(channelName)) {
    const channel = pusher.subscribe(channelName)
    subscribedChannels.set(channelName, channel)
  }
  return subscribedChannels.get(channelName)
}

function unsubscribeFromChannel(channelName) {
  if (subscribedChannels.has(channelName)) {
    pusher.unsubscribe(channelName)
    subscribedChannels.delete(channelName)
  }
}

export function onMentionReceived(callback) {
  const channelName = `private-user-${authStore.user.id}`
  const channel = subscribeToChannel(channelName)
  channel.bind('user-mentioned', callback)
}

export function onMentionsCleared(callback) {
  const channelName = `private-user-${authStore.user.id}`
  const channel = subscribeToChannel(channelName)
  channel.bind('user-mentions-cleared', callback)
}

export function onStockImportProgress(supplierId, callback) {
  const channelName = `private-supplier-${supplierId}-stock-import`
  const channel = subscribeToChannel(channelName)
  channel.bind('import-progress', callback)
}

export function unsubscribeStockImport(supplierId) {
  const channelName = `private-supplier-${supplierId}-stock-import`
  unsubscribeFromChannel(channelName)
}

export function onStockFileImported(callback) {
  const channelName = `private-user-${authStore.user.id}`
  const channel = subscribeToChannel(channelName)
  channel.bind('stock-file-imported', callback)
}

export function onCommentCreated(type, entityId, callback) {
  const channelName = `private-comments.${type}.${entityId}`
  const channel = subscribeToChannel(channelName)
  channel.bind('comment.created', callback)
}

export function unsubscribeComments(type, entityId) {
  unsubscribeFromChannel(`private-comments.${type}.${entityId}`)
}

export function onWebsiteStockImportProgress(callback) {
  const channelName = 'private-website-stock-import'
  const channel = subscribeToChannel(channelName)
  channel.bind('import-progress', callback)
}

export function unsubscribeWebsiteStockImport() {
  unsubscribeFromChannel('private-website-stock-import')
}

export function onRemindersDue(callback) {
  const channelName = `private-user-${authStore.user.id}`
  const channel = subscribeToChannel(channelName)
  channel.bind('reminders-due', callback)
}

export function onDeviceLoginRequested(callback) {
  const channelName = `private-user-${authStore.user.id}`
  const channel = subscribeToChannel(channelName)
  channel.bind('device-login-requested', callback)
}

export function onDeviceRevoked(callback) {
  const channelName = `private-user-${authStore.user.id}`
  const channel = subscribeToChannel(channelName)
  channel.bind('device-revoked', callback)
}

export function onAnnouncementCreated(callback) {
  const channelName = `private-user-${authStore.user.id}`
  const channel = subscribeToChannel(channelName)
  channel.bind('announcement-created', callback)
}
